module.exports = __webpack_public_path__ + "img/services2.7886bde6.jpg";